import {
  GET_CLUBS_LEADS,
  GET_CLUBS_LEADS_SUCCESS,
  GET_CLUB_LEAD_INFO,
  GET_CLUB_LEAD_INFO_SUCCESS,
  GET_CLUBS_LEADS_LOCATIONS_SUCCESS,
  GET_CLUBS_LEADS_LOCATIONS,
  GET_CLUBS_LEADS_LOCATIONS_ERROR,
  GET_CLUBS_LEADS_ERROR,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  clubsLeads: {},
  clubLeadInfo: {},
  clubLeadsLocations: [],
  loading: false,
  listLoading: false,
  listError: "",
  locationsLoading: false,
  locationsError: "",
}

const clubsLeads = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLUBS_LEADS_LOCATIONS:
      return { ...state, locationsLoading: true, locationsError: "", clubLeadsLocations: [] }
    case GET_CLUBS_LEADS_LOCATIONS_ERROR:
      return { ...state, locationsLoading: false, locationsError: action.payload }
    case GET_CLUBS_LEADS_ERROR:
      return { ...state, listLoading: false, listError: action.payload, clubsLeads: {} }
    case GET_CLUBS_LEADS_LOCATIONS_SUCCESS:
      state = {
        ...state,
        clubLeadsLocations: action?.data,
        locationsLoading: false,
      }
      break
    case GET_CLUBS_LEADS:
      state = {
        ...state,
        listLoading: true,
        listError: "",
        clubsLeads: {},
      }
      break
    case GET_CLUBS_LEADS_SUCCESS:
      state = {
        ...state,
        listLoading: false,
        clubsLeads: action.payload,
      }
      break
    case GET_CLUB_LEAD_INFO:
      state = {
        ...state,
        loading: true,
        error: "",
        clubLeadInfo: {},
      }
      break
    case GET_CLUB_LEAD_INFO_SUCCESS:
      state = {
        ...state,
        loading: false,
        clubLeadInfo: action.payload,
        error: "",
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, clubLeadInfo: {} }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default clubsLeads
